import React from "react";
import "./gif.css";

export default function AutoPlaySilentVideo() {
    // Verifica se o dispositivo é iOS (iPhone ou iPad)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    return (
        <div >
            {isIOS ? (
                <div className="video-container-IOS">
                    <iframe
                        
                        src="https://player.vimeo.com/video/1125192082?autoplay=1&loop=1&muted=1&background=1"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title="Vimeo Video"
                    ></iframe>
                </div>
            ) : (
                <div className="video-container">
                    <video className="gif" autoPlay lo  op muted playsInline>
                        <source src="/images/VideoSpi.mp4" type="video/mp4" />
                        Seu navegador não suporta vídeos.
                    </video>
                </div>

            )}
        </div>
    );
}



// import React from "react";
// import "./gif.css";

// export default function AutoPlaySilentVideo() {
//     return (
//         <div className="video-container">
//             <iframe
//                 className="gif"
//                 src="https://player.vimeo.com/video/1053417371?autoplay=1&loop=1&muted=1&background=1"
//                 frameBorder="0"
//                 allow="autoplay; fullscreen; picture-in-picture"
//                 allowFullScreen
//                 title="Vimeo Video"
//             ></iframe>
//         </div>
//     );
// }